import React, {useState, useEffect} from 'react';

const TimestampColumn = ({value, onChange}) => {

  const [enabled, setEnabled] = useState(!!value);

  useEffect(() => { onChange(enabled ? {} : null); }, [enabled]);

  return <div className="form-check mb-3">
    <input id="timestamp-column-enabled"
           type="checkbox"
           className="form-check-input"
           checked={enabled}
           onChange={e => setEnabled(e.target.checked)}/>
    <label className="form-check-label" htmlFor="timestamp-column-enabled">
      Add column with time of submission (timezone: UTC)
    </label>
  </div>
};
export default TimestampColumn;
